{
  "puan": {
    "Puan Tanımları": "Score Definities",
    "Baslik": "Score Definities",
    "Puan Adı": "Score Naam",
    "Puan (%)": "Score (%)",
    "Aralık ve Komisyon Tanımları": "Range- en Commissie Definities",
    "Yeni Aralık": "Nieuw Bereik",
    "Aralıkları Kopyala": "Bereiken Kopiëren",
    "Unvan": "Titel",
    "Min %": "Min %",
    "Max %": "Max %",
    "Komisyon %": "Commissie %",
    "İşlemler": "Acties",
    "Puan Ekle": "Score Toevoegen",
    "Puan Güncelle": "Score Bijwerken",
    "Aralık Ekle": "Bereik Toevoegen",
    "Aralık Güncelle": "Bereik Bijwerken",
    "Kaydet": "Opslaan",
    "Güncelle": "Bijwerken",
    "İptal": "Annuleren",
    "Sil": "Verwijderen",
    "Puan Tanımını Sil": "Score Definitie Verwijderen",
    "Aralık Sil": "Bereik Verwijderen",
    "bu puan tanımını ve bağlı tüm aralıkları silmek istediğinize emin misiniz?": "weet u zeker dat u deze score-definitie en alle bijbehorende bereiken wilt verwijderen?",
    "Bu aralık tanımını silmek istediğinize emin misiniz?": "Weet u zeker dat u deze bereik-definitie wilt verwijderen?",
    "Lütfen bir puan tanımı seçiniz": "Selecteer een score-definitie",
    "için aralıkları başka bir puandan kopyala:": "kopieer bereiken van een andere score voor:",
    "Min Yüzde": "Minimaal Percentage",
    "Max Yüzde": "Maximaal Percentage",
    "Komisyon (%)": "Commissie (%)",
    "Unvan Seçiniz": "Selecteer Titel",
    "Kaynak Puan": "Bron Score",
    "Puan Seçiniz": "Selecteer Score",
    "Kopyala": "Kopiëren",
    "Personel Unvan": "Personeel Titel",
    "Data Yenile": "Gegevens Vernieuwen",
    "Komisyon": "Commissie",
    "Düzeltme": "Bewerken",
    "Ara": "Zoeken",
    "Komisyon Hesaplanmaz": "Geen Commissie Berekend",
    "LutfenUnvanSeciniz": "Selecteer eerst een titel"
  }
}
